export default "__VITE_ASSET__Dv8JoQXQ__"